import { CAMPAIGN_STATUS } from '~/impact-measurement/constants';
import { CampaignTypes } from '~/types';

export enum DataGridTabs {
  draft = 'draft',
  live = 'live',
  pending = 'pending',
  error = 'error',
  complete = 'complete',
  proofServices = 'proof/services',
  servicesDraft = 'services/draft',
  trackingOnly = 'tracking only'
}

export const decorateGridTab = (tab: DataGridTabs) => {
  const isDraft = tab === DataGridTabs.draft;
  const isLive = tab === DataGridTabs.live;
  const isPending = tab === DataGridTabs.pending;
  const isError = tab === DataGridTabs.error;
  const isComplete = tab === DataGridTabs.complete;
  const isproofServices = tab === DataGridTabs.proofServices;
  const isServicesDraft = tab === DataGridTabs.servicesDraft;
  const isTrackingOnly = tab === DataGridTabs.trackingOnly;

  return {
    isDraft,
    isLive,
    isPending,
    isError,
    isComplete,
    isproofServices,
    isServicesDraft,
    isServices: isproofServices || isServicesDraft,
    isSoftware: isDraft || isLive || isError || isComplete,
    isTrackingOnly
  };
};

const CORE_TABS = [
  CAMPAIGN_STATUS.live,
  CAMPAIGN_STATUS.draft,
  CAMPAIGN_STATUS.pending,
  CAMPAIGN_STATUS.complete
];

const ADMIN_TABS = [
  ...CORE_TABS,
  CAMPAIGN_STATUS['proof/services'],
  CAMPAIGN_STATUS['services/draft']
];

type GetAdminTabsArgs = {
  isAdmin: boolean;
  isTrackingFeatureOn: boolean;
  isTrackingOnlyUser: boolean;
};

export const getAdminTabs = ({
  isAdmin,
  isTrackingFeatureOn,
  isTrackingOnlyUser
}: GetAdminTabsArgs) => {
  if (isTrackingOnlyUser && !isAdmin) return [CAMPAIGN_STATUS['tracking only']];

  if (isAdmin && isTrackingFeatureOn)
    return [...ADMIN_TABS, CAMPAIGN_STATUS['tracking only']];

  if (isAdmin) return ADMIN_TABS;

  return CORE_TABS;
};

type getCampaignTypeArgs = {
  isServices: boolean;
  isTrackingOnly: boolean;
};

export const getCampaignType = ({
  isServices,
  isTrackingOnly
}: getCampaignTypeArgs) => {
  if (isTrackingOnly) return CampaignTypes.TRACKING_ONLY;

  if (isServices) return CampaignTypes.SERVICE;

  return CampaignTypes.SOFTWARE;
};
